import React, { memo } from 'react';

import styled from 'styled-components';

import { LAYERS } from 'components/constants';

import { useReactiveVar } from '@apollo/client';
import { appState } from 'core';

import { Toast } from 'molecules';

export const GlobalToast = memo(() => {
  const { toasts } = useReactiveVar(appState);

  return (
    <Wrapper>
      {toasts?.map(({ id, data, type }) => (
        <Toast id={id} key={id} data={data} type={type} />
      ))}
    </Wrapper>
  );
});

// Левый нижний угол, как «Отменить» в Gmail: справа сверху плашка закрывала
// переключатель Slack / Почта / SMS коммуникатора и кнопки в шапке страниц,
// а справа снизу — кнопку отправки ответа.
const Wrapper = styled.div`
  position: fixed;
  left: 24px;
  bottom: 24px;
  display: flex;
  flex-direction: column;
  width: 380px;
  max-width: calc(100vw - 48px);
  pointer-events: none;
  z-index: ${LAYERS.TOAST};
`;
